export enum FeatureFlagsKeysEnum {
	IS_READY_ASSESS_ENABLED = 'isReadyAssessEnabled',
	IS_REPORTING_LIBRARY_ENABLED = 'isReportingLibraryEnabled',
	IS_RISK_REFERENCE_TAXONOMY_ENABLED = 'isRiskReferenceTaxonomyEnabled',
	IS_REGULATION_CHANGE_ENABLED = 'isRegulationChangeEnabled',
	IS_CHANGE_ENGINE_ENABLED = 'isChangeEngineEnabled',
	IS_REGULATION_INVENTORY_ENABLED = 'isRequirementInventoryEnabled',
	IS_RISK_CHANGE_ENABLED = 'isRiskChangeEnabled',
	IS_TESTING_AND_MONITORING_ENABLED = 'isTestingAndMonitoringEnabled',
	IS_AI_MODELS_ENABLED = 'isAiModelsEnabled',
	IS_AI_SIMULATION_AND_EXPERIMENTATION_ENABLED = 'isAiSimulationAndExperimentationEnabled',
	IS_PRCI_CREATION_ENABLED = 'isPrciCreationEnabled',
	IS_PRCI_GOVERNANCE_ENABLED = 'isPrciGovernanceEnabled',
	IS_INTEGRATIONS_ENABLED = 'isIntegrationsEnabled',
	IS_HORIZON_SCANNING_ENABLED = 'isHorizonScanningEnabled',
	IS_DATA_INGESTION_ENABLED = 'isDataIngestionEnabled',
	IS_RISK_GPT_ENABLED = 'isRiskGptEnabled',
	IS_MANAGEMENT_ENABLED = 'isManagementEnabled',
	IS_MULTI_LANGUAGE_ENABLED = 'isMultiLanguageEnabled',
	IS_ADMIN_OVERVIEW_ENABLED = 'isAdminOverviewEnabled',
	IS_ADMIN_USER_MANAGEMENT_ENABLED = 'isAdminUserManagementEnabled',
	IS_ADMIN_PERMISSIONS_ENABLED = 'isAdminPermissionsEnabled',
	IS_ADMIN_QUEUE_WORKFLOW_ENABLED = 'isAdminQueueWorkflowEnabled',
	IS_ADMIN_SYSTEM_ENABLED = 'isAdminSystemEnabled',
	IS_ADMIN_SECURITY_ENABLED = 'isAdminSecurityEnabled',
	IS_ADMIN_JOB_SCHEDULER_ENABLED = 'isAdminJobSchedulerEnabled',
	IS_ADMIN_ESCALATION_ENABLED = 'isAdminEscalationEnabled',
	IS_ADMIN_CHECKLIST_ENABLED = 'isAdminChecklistEnabled',
	IS_ADMIN_PROMPT_BUILDER_ENABLED = 'isAdminPromptBuilderEnabled',
	IS_DATA_INGESTION_ADVANCE_FILTER_ENABLED = 'isDataIngestionAdvanceFilterEnabled',
	IS_REGULATION_GRAPH_ENABLED = 'isRegulationGraphEnabled',
	IS_REGULATION_CHANGE_VIEWBY_DROPDOWN_ENABLED = 'isRegulationChangeViewByDropDownEnabled',
	IS_CONTROL_DEDUPLICATION_FILTER_ENABLED = 'isControlDeDuplicationFilterEnabled',
	IS_HOME_PAGE_SEARCH_ENABLED = 'isHomePageSearchEnabled',
	IS_HOME_PAGE_FILTER_ENABLED = 'isHomePageFilterEnabled',
	IS_TAXONOMY_DETAIL_FILTER_NODE_TYPE_ENABLED = 'isNodeTypeFilterEnabled',
	IS_TAXONOMY_DETAIL_FILTER_RISK_LEVEL_TYPE_ENABLED = 'isRiskLevelFilterEnabled',
	IS_TAXONOMY_DETAIL_NOTABLE_CHANGES_ENABLED = 'isNotableChangesEnabled',
	IS_AI_LANDING_PAGE_SETTING_BUTTON_ENABLED = 'isAILandingPageSettingEnabled',
	IS_AI_LANDING_PAGE_SECTION_SEARCH_ENABLED = 'isAILandingPageSectionSearchEnabled',
	IS_AI_LANDING_PAGE_SECTION_SORT_ENABLED = 'isAILandingPageSectionSortEnabled',
	IS_AI_LANDING_PAGE_SECTION_FILTER_ENABLED = 'isAILandingPageSectionFilterEnabled',
	IS_AI_LANDING_PAGE_SECTION_QA_TAB_ENABLED = 'isAILandingPageSectionQATabEnabled',
	IS_HOME_PAGE_GET_STARTED_BUTTON_ENABLED = 'isHomePageGetStartedButtonEnabled',
	IS_HOME_PAGE_LATEST_UPDATES_BUTTON_ENABLED = 'isHomePageLatestUpdatesButtonEnabled',
	IS_METRIC_STREAM_ENABLED = 'isMetricStreamEnabled',
	IS_CUBE_ENABLED = 'isCubeEnabled',
	IS_MICROSOFT_COPILOT_ENABLED = 'isMicroSoftCopilotEnabled',
	IS_SIGNAVIO_ENABLED = 'isSignavioEnabled',
	AI_SUMMARY_CHAR_MAX_LIMIT = 'aiSummaryMaxCharLimit',
	IS_ASKLINK_FEEDBACK_ENABLED = 'isAskLinkFeedBackEnabled',
	IS_THEME_ENABLED = 'isThemeEnabled',
	IS_REPORTING_LIBRARY_SEARCH_ENABLED = 'isReportingLibrarySearchEnabled',
	IS_REPORTING_LIBRARY_FILTER_ENABLED = 'isReportingLibraryFilterEnabled',
	IS_REPORTING_LIBRARY_ADD_REPORT_ENABLED = 'isReportingLibraryAddReportEnabled',
	IS_DATADOG_ENABLED = 'isDataDogEnabled',
	IS_TRIAL_PERIOD_ENABLED = 'isTrialPeriodEnabled',
	IS_TERMS_AND_CONDITION_ENABLED = 'isTermsAndConditionEnabled',
	IS_ADMIN_RESET_ENABLED = 'isAdminResetEnabled',
	IS_ADMIN_NOTIFICATIONS_ENABLED = 'isAdminNotificationsEnabled',
	IS_EXPORT_BUTTON_ENABLED = 'isExportButtonEnabled',
	IS_ASK_RISK_LINK_UPLOAD_FILE_ENABLED = 'isAskRiskLinkUploadFileEnabled',
	IS_PRC_CARD_VIEW_ENABLED = 'isPrcCardViewEnabled',
	ALLOWED_TENANTS = 'allowedTenants',
	IS_HOME_PAGE_APPROVALS_ENABLED = 'isHomePageMyApprovalEnabled',
	IS_HORIZON_SCANNING_ACTIVITY_FILTER_ENABLED = 'isHorizonScanningActivityFilterEnabled',
	IS_REG_PARSER_ENABLED = 'isRegParserEnabled',
	IS_SSO_LOGIN_ENABLED = 'isSsoLoginEnabled',
}
